import { FinancialsRowDataType } from '../../components/financials-table/types'

export { getColor, tickFormatter } from '../../components/line-stacked-bar-chart'

export function getSumData<T extends Pick<FinancialsRowDataType, 'values'>>(data: T[], absolute = false) {
  return data.reduce<Record<string, number>>((sumObj, revenue) => {
    revenue.values.forEach(({ year, value }) => {
      if (!sumObj[year]) {
        sumObj[year] = 0
      }

      sumObj[year] += absolute ? Math.abs(value ?? 0) : (value ?? 0)
    })

    return sumObj
  }, {})
}
